import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Params } from '@angular/router';

import { GroupService } from '../../services/group.service';

import { Study } from '../../models/study';
import { BasicError, Error403, Error409 } from '../../models/error/error';


@Component({
  selector: 'app-group-details-patient',
  templateUrl: './group-details-patient.component.html',
  styleUrls: ['./group-details-patient.component.css']
})
export class GroupDetailsPatientComponent implements OnInit {

  public studyid: String;
  public gDetails: Study;
  public loaded = false;


  constructor(private groupDetails: GroupService, private route: ActivatedRoute) {


  }

  ngOnInit() {
    this.route.paramMap.switchMap((params: ParamMap) => {
      this.studyid = params.get('id');

      return this.groupDetails.getGroupDetail(params.get('id'))
    }).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occured while reading study');
      } else if (data instanceof Study) {
        this.gDetails = data;
        this.loaded = true;
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group-details-patient/group-details-patient.component.ts